import { Box, IconButton, Menu, MenuButton, MenuList, MenuItem, Link } from '@chakra-ui/react'
import { FiShare2 } from 'react-icons/fi'
import { CITIZEN_PORTAL_ROUTES } from 'modules/CitizenPortal/constants/routes'

type MapShareButtonProps = {
  lat: number
  long: number
  afacode?: string
}

export default function MapShareButton({ lat, long, afacode }: MapShareButtonProps) {
  const encodedCoords = `${lat},${long}`

  const links = {
    impacto: afacode
      ? `${CITIZEN_PORTAL_ROUTES.MAP}?afacode=${afacode}`
      : `${CITIZEN_PORTAL_ROUTES.MAP}?lat=${lat}&lon=${long}`,
    google: `https://www.google.com/maps?q=${encodedCoords}`,
    openStreetMap: `https://www.openstreetmap.org/?mlat=${lat}&mlon=${long}#map=16/${lat}/${long}`,
    // apple: `http://maps.apple.com/?ll=${encodedCoords}`,
    waze: `https://waze.com/ul?ll=${encodedCoords}&navigate=yes`,
  }

  return (
    <Box position="absolute" bottom="2" right="2" zIndex={10}>
      <Menu placement="top-end">
        <MenuButton
          as={IconButton}
          icon={<FiShare2 />}
          aria-label="Compartilhar localização"
          colorScheme="primary"
          size="sm"
          borderRadius="full"
          shadow="md"
          onClick={(e) => e.stopPropagation()}
        />
        <MenuList>
          <MenuItem as={Link} href={links.impacto} isExternal onClick={(e) => e.stopPropagation()}>
            Plataforma Impacto
          </MenuItem>
          <MenuItem as={Link} href={links.google} isExternal onClick={(e) => e.stopPropagation()}>
            Google Maps
          </MenuItem>
          <MenuItem as={Link} href={links.openStreetMap} isExternal onClick={(e) => e.stopPropagation()}>
            OpenStreetMap
          </MenuItem>
          {/* <MenuItem as={Link} href={links.apple} isExternal onClick={(e) => e.stopPropagation()}>
            Apple Maps
          </MenuItem> */}
          <MenuItem as={Link} href={links.waze} isExternal onClick={(e) => e.stopPropagation()}>
            Waze
          </MenuItem>
        </MenuList>
      </Menu>
    </Box>
  )
}
